import { css } from 'lit';

// these styles can be imported from any component
// for an example of how to use this, check /pages/about-about.ts
export const styles = css`

  .category-filter {
    margin: 5px;
  }

  // sl-button.category-filter::part(base) {
  //   /* Set design tokens for height and border width */
  //   --sl-input-height-medium: 48px;
  //   --sl-input-border-width: 4px;

  //   background-color: var(--sl-color-green-300);
  //   border-color: var(--sl-color-green-900);
  //   color: white;
  //   font-size: 1.125rem;
  // }

`;